import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { FlightService } from '../../flight.service';
import { ApiHandlerService } from '../../../../core/api-handlers';
import { AlertService } from '../../../../core/services/alert.service';
import { SubSink } from 'subsink';
import { UtilityService } from '../../../../core/services/utility.service';
import { SwalService } from '../../../../core/services/swal.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatModalService, ModalConfigDataI } from 'projects/b2c/src/app/core/services/mat-modal.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-confirm-passenger',
    templateUrl: './confirm-passenger.component.html',
    styleUrls: ['./confirm-passenger.component.scss']
})
export class ConfirmPassengerComponent implements OnInit, OnDestroy {

    @ViewChild('gotoBaggageProtection', { static: false }) private gotoBaggageProtection: ElementRef<HTMLDivElement>;
    baggageForm: FormGroup
    baggagelist: any;
    passengers: any;
    contact: any;
    flights: any;
    flightsFare: any;
    price: any;
    attr: any;
    baggageProtected: boolean = false;
    loadingTemplate: any;
    loading: boolean;
    protected subs = new SubSink();
    modalConfigData: ModalConfigDataI;
    subscription: Subscription;
    bookingSource;
    baggeData = {
        isProtected: false,
        data: { Total_Price: 0 }
    };
    contactDetails: any;
    passengerDetails: any;
    flight: any;
    commitBookReq: any;
    currentUser: any;
    baggageLoaded: Promise<boolean>;
    countries: any;
    baggageRadio: any = true;
    submitted: boolean = false;
    traveller:any;
    isSeatInfoNotEmpty:boolean=false;
    paymentData: any;
    convenienceFee: any;

    constructor(
        private router: Router,
        private flightService: FlightService,
        private apiHandlerService: ApiHandlerService,
        private alertService: AlertService,
        private utility: UtilityService,
        private swalService: SwalService,
        private fb: FormBuilder,
        private matModalService: MatModalService,
        private cdRef: ChangeDetectorRef
    ) {
        
    }

    ngOnInit() {
        this.subs.sink = this.flightService.bookingSource.subscribe(res => {
            this.bookingSource = res;
        });

        this.flightService.countryList.subscribe(res => {
            this.countries = res;
        });

        this.subs.sink = this.flightService.passengerDetails.subscribe(res => {
            this.passengers = res[1].passengers;
            this.enableSeat(res);
            this.contact = res[1].contact;
            this.commitBookReq = res[0];
            this.cdRef.detectChanges()
        });
        this.baggageForm = this.fb.group({
            baggageProtection: ['', Validators.required]
        })
        this.subs.sink = this.flightService.loading.subscribe(res => {
            this.loading = res;
        });
        this.subs.sink = this.flightService.bookingFlightData.subscribe(res => {
            if (typeof res == 'object' && res.JourneyList.hasOwnProperty('FlightDetails')) {
                this.flightService.extraFees.next(this.flightService.extraFees.value);
                this.traveller = this.flightService.traveller;
                this.flight = res.JourneyList;
            } else {
                this.router.navigate(['flight/result']);
            }
        })
        this.getBaggageValue();
        this.subs.sink = this.flightService.CommitBookingResponse.subscribe(res => {
            this.flights = res;
            this.convenienceFee = res.Price.ConvinenceFee;
            this.flightsFare = res;
            this.price = res.Price;
            this.attr = res.Attr;
        });
        this.currentUser = JSON.parse(sessionStorage.getItem('b2cUser'));
    }

    getCountryName(code) {
        let ob = this.countries.find(el => el.code == code)
        return ob.name
    }

    editPassengers() {
        this.flightService.editPassenger.next(true)
        this.router.navigate(['/flight/guest-details']);
    }

    passengerType(code): string {
        let result = 'Infant';
        switch (code) {
            case 'ADT':
                result = 'Adult';
                break;
            case 'CHD':
                result = 'Child';
                break;

            default:
                break;
        }
        return result;
    }

    passengerName(obj): string {
        return obj.FirstName + ' ' + obj.MiddleName + ' ' + obj.LastName;
    }

    submitBaggageCharge() {
        this.subs.sink = this.apiHandlerService.apiHandler('servicePurchase', 'post', {}, {}, { app_reference: this.flightService.CommitBookingResponse.value.AppReference, booking_source: this.bookingSource }).subscribe(resp => {
            // console.log(resp);

            // if ((resp.statusCode == 200 || resp.statusCode == 201) && !resp.data.hasOwnProperty("Data")) {
            //     this.flightService.baggeProtectionData.next({
            //         isProtected: true,
            //         data: resp.data[0]
            //     });
            //     this.baggeData = {
            //         isProtected: true,
            //         data: resp.data[0],
            //     }
            // } else {
            //     this.swalService.alert.oops(resp.data.Errors[0]['ErrorMessage'] || '');
            // }
        }, err => {
            // console.log(err);
            // Radha DD
            // this.swalService.alert.oops();
        });
    }


    onFinalBooking() {
        this.submitted = true;
        let baggageProtection = this.baggageForm.value.baggageProtection;
        if (baggageProtection) {
            this.subs.sink = this.apiHandlerService.apiHandler('servicePurchase', 'post', {}, {}, {
                app_reference: this.flightService.appReference,
                booking_source: this.flight.booking_source
            }).subscribe(resp => {
                if (resp.statusCode == 200 || resp.statusCode == 201) {
                }
            });
        }

        this.onReservation();
    }


    intitiatePayment(){
        let date = (new Date().getTime()).toString();
        const userId = this.utility.readStorage('b2cUser', sessionStorage)['id']
        const order_id = `IR${date.substring(10)}${date.substring(0, 7)}${date.substring(7)}`;
        let payload = {
            app_reference: this.flightService.CommitBookingResponse.value.AppReference,
            order_id: order_id,
            payment_type: "Stripe",
            merchantInvoiceNumber: "Inv002",
            source: "flight",
            userId: userId ? userId : 0,
        }
        localStorage.setItem('orderId',order_id);
        this.subs.sink = this.apiHandlerService.apiHandler('transactionInit', 'post', '', '', payload).subscribe(res => {
            if (res) {
                this.paymentData = res.data;
                const redirectUrl = this.paymentData.url;
                window.location.href = redirectUrl;
            }
        });
    }

    onReservation() {
        this.flightService.loading.next(true);
        if (this.flightService.isDevelopment) {
            setTimeout(_ => {
                this.flightService.loading.next(false);
                this.router.navigate(['/search/flight/booking-confirm']);
            }, 3000);
        } else {
            if (this.baggageProtected) {
                this.submitBaggageCharge();
            }
            console.log(this.flightService.CommitBookingResponse)
            const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
            this.subs.sink = this.apiHandlerService.apiHandler('finalBooking', 'POST', '', '', {
                created_by_id,
                ResultToken: this.flightService.CommitBookingResponse.value.ResultToken,
                booking_source: this.flightService.CommitBookingResponse.value.booking_source,
                AppReference: this.flightService.CommitBookingResponse.value.AppReference
            }).subscribe(res => {
                this.flightService.loading.next(false);
                if (res.Status && res.data.hasOwnProperty('FinalBooking')) {
                    this.flightService.FinalBookingResponse.next(res.data.FinalBooking.BookingDetails);
                    sessionStorage.setItem('paymentPageLoadData', JSON.stringify(this.flight));
                    this.router.navigate(['/flight/booking-confirm'], {
                        queryParams: {
                            AppReference: this.flightService.CommitBookingResponse.value.AppReference,
                            ReservationResultIndex: res.data.ReservationResultIndex
                        }
                    });
                    this.flightService.bookingSource.next('');
                } else {
                    this.swalService.alert.oops(res.Message);
                    setTimeout(() => {
                        this.router.navigate(['/flight/result']);
                    }, 100);
                }
                this.flightService.loading.next(false);
            }, (err: HttpErrorResponse) => {
                this.flightService.loading.next(false);
                const { error } = err;
                switch (error.statusCode) {
                    case 400:
                        this.swalService.alert.oops(error.Message);
                        break;
                    default:
                        this.swalService.alert.oops(error.Message);
                        break;
                }

            });
        }
    }

    confirmBooking() {
        this.flightService.loading.next(true);
        if (this.flightService.isDevelopment) {
            setTimeout(_ => {
                this.flightService.loading.next(false);
                this.router.navigate(['/search/flight/booking-confirm']);
            }, 3000);
        } else {
            if (this.baggageProtected) {
                this.submitBaggageCharge();
            }
            console.log(this.flightService.CommitBookingResponse)
            const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['id'];
            this.subs.sink = this.apiHandlerService.apiHandler('finalBooking', 'POST', '', '', {
                created_by_id,
                ResultToken: this.flightService.CommitBookingResponse.value.ResultToken,
                booking_source: this.flightService.CommitBookingResponse.value.booking_source,
                AppReference: this.flightService.CommitBookingResponse.value.AppReference
            }).subscribe(res => {
                this.flightService.loading.next(false);
                if (res.Status && res.data.hasOwnProperty('FinalBooking')) {
                    this.flightService.FinalBookingResponse.next(res.data.FinalBooking.BookingDetails);
                    sessionStorage.setItem('paymentPageLoadData', JSON.stringify(this.flight));
                    this.intitiatePayment();
                    this.flightService.bookingSource.next('');
                } else {
                    this.swalService.alert.oops(res.Message);
                    setTimeout(() => {
                        this.router.navigate(['/flight/result']);
                    }, 100);
                }
                this.flightService.loading.next(false);
            }, (err: HttpErrorResponse) => {
                this.flightService.loading.next(false);
                const { error } = err;
                switch (error.statusCode) {
                    case 400:
                        this.swalService.alert.oops(error.Message);
                        break;
                    default:
                        this.swalService.alert.oops(error.Message);
                        break;
                }

            });
        }
    }
   
    hasError = (controlName: string, errorName: string, arrayControl?: string) => {
        if (typeof arrayControl !== 'undefined') {
            let formArrayName = this.baggageForm.get(arrayControl) as FormArray;
            if (formArrayName && formArrayName != null)
                return ((this.submitted || formArrayName.controls[controlName].touched) && formArrayName.controls[controlName].hasError(errorName));
        }
    }

    getData() {
        this.subscription = this.matModalService.getData().subscribe(res => {
            if (!res.noData && !this.baggageForm.value.baggageProtection) {
                this.subscription.unsubscribe();
                this.gotoBaggageProtection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            } else {
                this.subscription.unsubscribe();
                this.onFinalBooking();
            }
        })
    }

    getBaggageValue() {
        this.subs.sink = this.apiHandlerService.apiHandler('baggageproductList', 'post', {}, {}, {}).subscribe(resp => {
            if ((resp.statusCode == 200 || resp.statusCode == 201)) {
                this.baggagelist = resp.data[0];
                this.baggageLoaded = Promise.resolve(true);
                this.cdRef.detectChanges()
            } else {
                this.swalService.alert.oops(resp.data.Errors[0]['ErrorMessage'] || '');
            }
        }, err => {
            this.swalService.alert.oops();
        });
    }

    updateBaggage(val) {
        let baggageData = {
            // booking_source: this.commitBookReq.booking_source,
            booking_source: "B2C",
            app_reference: this.commitBookReq.AppReference,
            baggagePrice: this.baggagelist.ProductPrice
        }

        if (val) {

            this.subs.sink = this.apiHandlerService.apiHandler('updateLostBaggageProtectionPrice', 'post', {}, {}, baggageData).subscribe(resp => {
                if ((resp.statusCode == 200 || resp.statusCode == 201)) {
                    this.baggageProtected = true;
                    // this.price = resp.data.Price;
                    const obj = Object.assign({}, this.flightsFare, resp.data)
                    this.flightsFare = obj;
                    this.flight = this.flightsFare;
                    this.cdRef.detectChanges();
                } else {
                    this.baggageProtected = false;
                    // this.price = resp.data.Price;
                    this.cdRef.detectChanges();
                    this.swalService.alert.oops(resp.data.Errors[0]['ErrorMessage'] || '');
                }
            }, err => {
                this.swalService.alert.oops();
            });

        } else {
            if (this.flightsFare.Price.PriceBreakup.TotalLostBaggageProtection) {
                baggageData.baggagePrice = -this.flightsFare.Price.PriceBreakup.TotalLostBaggageProtection;
            } else {
                baggageData.baggagePrice = 0;
            }
            this.subs.sink = this.apiHandlerService.apiHandler('updateLostBaggageProtectionPrice', 'post', {}, {}, baggageData).subscribe(resp => {
                if (resp.statusCode == 200 || resp.statusCode == 201) {
                    const obj = Object.assign({}, this.flightsFare, resp.data)
                    this.flightsFare = obj;
                    this.flight = this.flightsFare
                    this.cdRef.detectChanges();
                }
            });
        }
    }

    enableSeat(res) {
        const currentUser = this.utility.readStorage('b2cUser', sessionStorage);
        if (res && (res[0].booking_source == 'ZBAPINO00002' || res[0].booking_source == 'ZBAPINO00007') && currentUser && currentUser.id == 44) {
            this.isSeatInfoNotEmpty = this.checkSeatSelection(this.passengers);
        }
    }

    checkSeatSelection(passengers) {
        let hasValue = false;
        for (const passenger of passengers) {
            if (passenger.SeatId.length > 0) {
                hasValue = true;
                break;
            }
        }
        return hasValue;
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

}